<template>
  <div class="app-shop-wrapper">
    <slot name="txtHeadline"></slot>
    <div class="powered-by-otelo shop-teaser" v-if="tariffs.bookablePresalesTariffs.length > 1">
      <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6" v-for="(tariff) in fullTariffs" :key="tariff.tariffId">
          <div class="product-blister-box">
            <div class="product-blister">
              <div class="blister-name">{{tariff.tariffExtra.name}} <sup class="extra-html">{{tariff.tariffExtra.extraHtml}}</sup></div>
              <div class="blister-volume"> <span class="volume">{{tariff.tariffExtra.volume}}</span> <br> <span class="volume-type">{{tariff.tariffExtra.type}}</span></div>
              <div class="blister-quantity"><span class="quantity">{{tariff.tariffExtra.quantity}} <br> {{tariff.tariffExtra.quantityUnit}}</span></div>
              <div class="blister-price"><span class="price">{{tariff.formattedBasicFee}}</span><br><span class="amount-duration">Für {{tariff.runtime.amount}} {{tariff.runtime.formattedUnit}}</span></div>
              <div class="blister-sub"><span class="desc">
                Starterpaket einmalig {{tariff.starterKit[0].formattedSinglePaymentFee}} <br>
                {{tariff.tariffExtra.name}} die ersten 4 Wochen inkl.
              </span>
              </div>
              <div class="blister-btn">
                <a :href="tariff.tariffExtra.iconTarget + '?prod=' + tariff.tariffId">
                  <slot name="blisterBtn">
                    <button>In den Warenkorb</button>
                  </slot>
              </a>
              </div>
            </div>
            <div class="product-pib">
              <a :href="tariff.tariffExtra.pib" class="link-pbo">Produktinformationsblatt</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import slotProxy from '@/mixins/slotProxy'
import extraData from '@/mixins/extraData'
import joinTariffExtra from '@/helper/joinTariffExtras'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import { mapGetters, mapMutations } from 'vuex'
import transaction from '@/mixins/transaction'

export default {
  name: 'ShopWrapper',
  data () {
    return {
      presalesTariff: {
        bookablePresalesTariffs: {}
      },
      decodedExtra: {}
    }
  },
  computed: {
    tariffs: function () {
      return this.presalesTariff
    },
    fullTariffs: function () {
      return this.presalesTariff.bookablePresalesTariffs.map(tariff => {
        return joinTariffExtra(tariff, this.extraData)
      })
    },
    ...mapGetters([
      'brand'
    ])
  },
  methods: {
    ...mapMutations('orderProduct/product', [
      'commitTariffId'
    ])
  },
  mixins: [
    slotProxy(),
    extraData(),
    transaction('order')
  ],
  mounted () {
    this.commitTariffId(null)
  },
  apollo: {
    presalesTariff: function () {
      return wrapQuery(
        gql`query order ($brand: String!) {
            presalesTariff(brand: $brand) {
                bookablePresalesTariffs {
                  tariffId
                  name
                  basicFee
                  formattedBasicFee
                  connectionFee
                  contractPeriod
                  marketingGroup
                  phoneFlat
                  smsFlat
                  runtime {
                    amount
                    formattedUnit
                    unit
                  }
                  starterKit {
                    creditBalance
                    productNumber
                    shippingCost
                    singlePaymentFee
                    formattedCombinedCost
                    formattedShippingCost
                    formattedSinglePaymentFee
                    withDevice
                    withMnp
                  }
                  volumes {
                    amount
                    formattedUnit
                    unit
                  }
                }
            }
}`, this, ['presalesTariff'], { brand: this.brand }, function (data) {
        }
      )
    }
  }
}
</script>
